export class DropdownItem {
  constructor(public text: string, public handler: Handler, public icon?: string) {}
}

type Handler = (data: any | null) => void;
